module.exports = __webpack_public_path__ + "static/img/02.ab26859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/05/02.jpg
// module id = HCR8
// module chunks = 1